import request from "@/utils/request";

export const url = {
  GroupPredictAsync_List: "/api/GroupPredictRoomStatus/GroupPredictAsync",
  Room_Available: "/api/ARI/GetAvailableRooms", //获取可用房型
  Order_GetContact: "/api/GroupOrder/GetOrderByContactPageList", // 通过姓名查询客人订单历史记录
};
function sendRequest(apiUrl, params, type) {
  return request({
    url: apiUrl,
    method: type,
    data: params,
  });
}

export default class roomApi {
  /**
   * 获取房态信息
   * @description: 获取房态
   * @param {Object} data
   * @return:
   */
  static GetGroupRoomForecast(params, type = "post") {
    return sendRequest(url.GroupPredictAsync_List, params, type);
  }
  /**
   * 获取可用房型
   * @description:  获取可用房型
   * @param {Object} data 搜索条件
   * @return:
   */
  static GetRoomAvailable(params, type = "post") {
    return sendRequest(url.Room_Available, params, type);
  }
  /**
   * 获取联系人
   * @description:  获取联系人
   * @param {Object} data 搜索条件
   * @return:
   */
  static GetContact(params, type = "post") {
    return sendRequest(url.Order_GetContact, params, type);
  }
}
